module.exports = __webpack_public_path__ + "src/assets/star-bright.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star-bright.svg
// module id = 33
// module chunks = 0